import React from "react";
import type { SortableValue } from "diagnostics-lib/comparator";
import { comparator, comparatorBy, withOrder } from "diagnostics-lib/comparator";
export default function useSortedData<Data>(
  data: Data[],
  selector: (d: Data) => SortableValue | undefined | null,
  sortOrder: "asc" | "desc",
) {
  return React.useMemo(() => {
    const [nilValues, others] = data.reduce<[Data[], Data[]]>(
      (acc, d) => {
        const v = selector(d);
        if (v === null || v === undefined || v === "") {
          acc[0].push(d);
        } else {
          acc[1].push(d);
        }

        return acc;
      },
      [[], []],
    );
    others.sort(comparatorBy(selector, withOrder(comparator, sortOrder)));

    return others.concat(nilValues);
  }, [data, selector, sortOrder]);
}
